// src/components/myAccount/MyAccountHeader.js
import React from 'react';
import { useLocation } from 'react-router-dom';
import UserMenu from '../common/UserMenu';

const MyAccountHeader = ({ user, userProfile, userRole }) => {
  const location = useLocation();

  const getPageTitle = () => {
    const path = location.pathname;
    if (path.includes('/dashboard')) return 'Dashboard';
    if (path.includes('/profile')) return 'Profile';
    if (path.includes('/login-details')) return 'Login Details';
    if (path.includes('/subscriptions')) return 'Subscriptions';
    if (path.includes('/payment-methods')) return 'Payment Methods';
    if (path.includes('/billing-history')) return 'Billing History';
    if (path.includes('/invoices')) return 'Invoices';
    return 'My Account';
  };

  return (
    <header className="bg-white border-b border-gray-200">
      <div className="px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Left side - Page Title */}
          <div>
            <h1 className="text-2xl font-semibold text-gray-900">
              {getPageTitle()}
            </h1>
          </div>

          {/* Right side - User Menu */}
          <div className="flex items-center space-x-4">
            {user && (
              <UserMenu 
                user={user}
                userProfile={userProfile}
                userRole={userRole}
              />
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default MyAccountHeader;